import { Component, OnInit } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';
import { ServiceService, Imovel } from '../service.service';
import { Router } from '@angular/router';
import { trigger, transition, query, style, stagger, animate } from '@angular/animations';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  // animations: [
  //   trigger('animation', [
  //     transition('*=>*', [
  //       query(':enter', style({opacity: 0}), {optional: true}),
  //       query(':enter', stagger('200ms', [
  //         animate('.3s ease-in', style({opacity: 1}))
  //       ]))
  //     ])
  //   ])
  // ]
})
export class HomeComponent implements OnInit {

  tipo = '';
  listImovel: Imovel[] = [];
  listImovelTemp = []
  constructor(
    private _service: ServiceService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {

  }

  ngOnInit() {
    this._service.getAll().subscribe(data => {
      console.log(data.records);
      this.listImovel = data.records;
      this.listImovelTemp = data.records;
      this.listImovel.forEach(el => {
        const url = `http://www.vanguardacondominios.com.br/imobiliaria/admin/webroot/files/imoveis/${el['id']}/${el['img_lista']}`;
        Object.assign(el, { imgUrl: this.sanitizer.bypassSecurityTrustStyle(`url(${url})`) });
      });
      this.listImovelTemp.forEach(el => {
        const url = `http://www.vanguardacondominios.com.br/imobiliaria/admin/webroot/files/imoveis/${el['id']}/${el['img_lista']}`;
        Object.assign(el, { imgUrl: this.sanitizer.bypassSecurityTrustStyle(`url(${url})`) });
      });
      this.filter('casa')
    });
  }

  filter(value){
    this.listImovelTemp = this.listImovel.filter(item=>{
      return item.tipo == value
    })
  }

  routerEvent(event) {
    /* this.router.navigate(['/vitrine']); */
    this.router.navigate([event]);
  }

  sani(value){
    return this.sanitizer.bypassSecurityTrustStyle('url(' + value + ')') ;
  }

}
